import Rete from "rete";

export const genericSocket = new Rete.Socket("Value");
